module.exports = __webpack_public_path__ + "img/mingsheng_icon_active.308f1204.png";